import { render, staticRenderFns } from "./VerificaUltimoEnvio.vue?vue&type=template&id=5dc2056e&scoped=true&"
import script from "./VerificaUltimoEnvio.vue?vue&type=script&lang=js&"
export * from "./VerificaUltimoEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2056e",
  null
  
)

export default component.exports